import { Box, Skeleton } from '@mui/material';

export function CardSkeleton() {
    return (
        <Box sx={{ m: 1 }}>
            <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
        </Box>
    );
}

export function PulsateCardSkeleton() {
    return (
        [1, 2, 3, 4, 5].map((d) => (<Box key={d} sx={{ width: 220, marginRight: 0.5}}>
            <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
            <Box sx={{ pt: 1 }}>
                <Skeleton height={20} />
                <Skeleton width="60%" height={20} />
            </Box>
        </Box>))
    );
}

export function SmallCardSkeleton(){
    return(
        <Box sx={{ pt: 1 }}>
            <Skeleton variant="rectangular" height={50} width={{xs: 190 ,md:300}} sx={{ borderRadius: 2 }} />
        </Box>
    )
}

export function RowCardSkeleton(){
    return(
        <Box sx={{ pt: 1 ,display:'flex', flexDirection:'row' , marginRight:'10px'}}>
            <Skeleton variant="rectangular" height={100} width={{xs: 240 ,md:280}} sx={{ borderRadius: 2 }} />
        </Box>
    )
}
